export default "__VITE_ASSET__4UUjKOPo__"